import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import api from '../utils/api';
import { API_URL } from '../components/config';
import { getViewAsMode } from '../utils/viewMode';
import './HarvestingTopNav.css';

/**
 * Shared top navigation for all Harvesting Portal pages so users can always
 * get back to the harvesting home and jump between the pages staff have
 * toggled on (ordered by each page's Display Order).
 */
const HarvestingTopNav = () => {
  const location = useLocation();
  const [navPages, setNavPages] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const viewAsMode = getViewAsMode(location.search);
  const previewMode = Boolean(viewAsMode);
  const previewQuery = viewAsMode ? `?viewAs=${viewAsMode}` : '';

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const fetchNavPages = async () => {
      try {
        const response = previewMode
          ? await axios.get(`${API_URL}/api/harvesting-pages`)
          : await api.get('/api/harvesting-pages');
        const pages = response.data?.pages || [];
        const toggled = pages
          .filter((p) => p.showInNav)
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        setNavPages(toggled);
      } catch (err) {
        setNavPages([]);
      }
    };
    fetchNavPages();
  }, [previewMode]);

  const pageHref = (page) => {
    if (page.isLandingPage) return `/harvesting${previewQuery}`;
    if (page.slug === 'harvest-report') return `/harvesting/pages/harvest-report?cipView=log&fullscreen=1${previewQuery ? `&${previewQuery.slice(1)}` : ''}`;
    if (page.parentSlug) return `/harvesting/pages/${page.parentSlug}/${page.slug}${previewQuery}`;
    return `/harvesting/pages/${page.slug}${previewQuery}`;
  };

  return (
    <div className="topic-pages-nav-wrap">
      <button
        type="button"
        className="topic-pages-nav-toggle"
        aria-expanded={mobileMenuOpen}
        onClick={() => setMobileMenuOpen((open) => !open)}
      >
        <span>Harvesting Sections</span>
        <span aria-hidden="true">{mobileMenuOpen ? '×' : '☰'}</span>
      </button>
      <nav className={`topic-pages-nav${mobileMenuOpen ? ' topic-pages-nav--open' : ''}`} aria-label="Harvesting sections">
        <Link to={`/harvesting${previewQuery}`} className="topic-page-link" onClick={() => setMobileMenuOpen(false)}>Harvesting Home</Link>
        {navPages.map((page) => (
          <Link key={page._id} to={pageHref(page)} className="topic-page-link" onClick={() => setMobileMenuOpen(false)}>
            {page.title}
          </Link>
        ))}
      </nav>
    </div>
  );
};


export default HarvestingTopNav;
